@if (usersForm && showAsTable) {
<form [formGroup]="usersForm" class="fuo-table-container">

  <div class="fuo-table-banner">
    <div class="fuo-table-banner-actions">
      <button type="button" class="fuo-add-row-btn" (click)="addRow()">
        <i class="fa fa-plus" aria-hidden="true"></i>{{'field.label.add_new_row'  | translate | async }}
      </button>
    </div>
  </div>

  <div class="fuo-table-scroll" formArrayName="users">
    <table class="fuo-table">
      <thead>
        <tr>
          <th class="fuo-table-index">#</th>
          @for (question of rowQuestions[0]; track question.key) {
          @if (question.controlType !== 'hidden' && question.key) {
          <th>
            {{ question.label | translate | async }}
            @if (question.required) {
            <span class="fuo-required">*</span>
            }
            @if (question.key === 'login_id') {
            <span class="fuo-table-hint">(System Generated)</span>
            }
          </th>
          }
          }
          <th class="fuo-table-action">{{'f.l.action'  | translate | async }}</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows.controls; track row; let i = $index) {
        <tr [formGroupName]="i">
          <td class="fuo-table-index">{{ i + 1 }}</td>
          @for (question of rowQuestions[i]; track question.key) {
          @if (question.controlType !== 'hidden' && question.key) {
          <td [class.fuo-table-cell-error]="showError(row, question)">
            <dhs-form-question class="fuo-table-question" [decorator]="decorator" [question]="question" [form]="row" [insideGrid]="'true'"
              [validIn]="submitted" [index]="i" (valueChanged)="onValueChanged($event, row)">
            </dhs-form-question>
            @if (showError(row, question)) {
            <p class="fuo-error fuo-table-error">
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              {{ question.label | translate | async }} is required
            </p>
            }
          </td>
          }
          }
          <td class="fuo-table-action">
            <button type="button" class="fuo-table-icon-btn" [disabled]="rows.length <= 1"
              [attr.aria-label]="'Remove user ' + (i + 1)" (click)="removeRow(i)">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
            <button type="button" class="fuo-table-icon-btn" [attr.aria-label]="'Duplicate user ' + (i + 1)"
              (click)="copyRow(i)">
              <i class="fa fa-copy" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="fuo-container-fw">
     <button type="button" class="fuo-add-btn mt-3" (click)="addRow()">
      <i class="fa fa-plus" aria-hidden="true"></i>{{'field.label.add_new_row'  | translate | async }}
    </button>
  </div>

  <div class="fuo-table-footer">
    <div class="fuo-tips">

    </div>
    <button type="button" class="fuo-submit-btn" (click)="onSubmit()">
      {{'field.label.submit'  | translate | async }}
      <i class="fa fa-paper-plane" aria-hidden="true"></i>
    </button>
  </div>
</form>
}

@if (usersForm && !showAsTable) {
<form [formGroup]="usersForm" class="fuo-container">
  <div formArrayName="users">
    @for (row of rows.controls; track row; let i = $index) {
    <div [formGroupName]="i" class="fuo-card" [class.fuo-card-complete]="isRowReady(row)">
      <div class="fuo-card-head">
        <div class="fuo-card-head-left">
          <div class="fuo-card-head-text">
            <span class="fuo-user-label"> {{'field.label.user'  | translate | async }} {{ i + 1 }}</span>
          </div>
        </div>
        <button type="button" class="fuo-remove-btn" [attr.aria-label]="'Remove user ' + (i + 1)" (click)="removeRow(i)"
          [disabled]="rows.length <= 1" title="Remove user">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </div>

      <div class="fuo-grid">
        @for (question of rowQuestions[i]; track question.key) {
        @if (question.controlType !== 'hidden' && question.key) {
        <div class="fuo-field">
          <label class="fuo-label" [attr.for]="question.key + '-' + i">
            {{ question.label | translate | async }}
            @if (question.required) {
            <span class="fuo-required">*</span>
            }
          </label>
          <dhs-form-question class="fuo-question" [decorator]="decorator" [question]="question" [form]="row" [insideGrid]="'true'"
            [validIn]="submitted" [index]="i" (valueChanged)="onValueChanged($event, row)">
          </dhs-form-question>

          @if (showError(row, question)) {
          <p class="fuo-error">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
             {{ 'field.label.enter_value' | translate | async }}
          </p>
          }
        </div>
        }
        }
      </div>
    </div>
    }
  </div>

  <div class="fuo-container-fw">
    <button type="button" class="fuo-add-btn" (click)="addRow()">
    <i class="fa fa-plus" aria-hidden="true"></i> {{ 'field.label.add_another_user' | translate | async }}
  </button>
  </div>
  
  <div class="fuo-footer">
    <div class="fuo-summary">
      <span class="fuo-summary-count" [class.fuo-summary-count-complete]="readyCount() === rows.length">{{ readyCount()
        }}</span>
      <span>of {{ rows.length }} {{ rows.length === 1 ? 'user' : 'users' }} {{ 'field.label.ready_to_submit' | translate | async }}</span>
    </div>
    <button type="button" class="fuo-submit-btn" (click)="onSubmit()">
      {{ 'field.label.submit_users' | translate | async }}
      <i class="fa fa-arrow-right" aria-hidden="true"></i>
    </button>
  </div>
</form>
}